import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { useAuth } from '../context/AuthContext';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { user, logout } = useAuth();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const isActive = (path) => location.pathname === path ? 'active' : '';

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="navbar-inner">
          <Link to="/" className="navbar-logo">
            <div className="logo-icon">⚡</div>
            <span className="text-gradient">InfraVelox</span>
          </Link>

          <div className="navbar-links">
            <Link to="/" className={isActive('/')}>Home</Link>
            <Link to="/pricing" className={isActive('/pricing')}>Pricing</Link>
            <a href="/#tools">Tools</a>
            <a href="/#how-it-works">How It Works</a>
            <Link to="/contact" className={isActive('/contact')}>Contact</Link>
          </div>

          <div className="navbar-actions">
            {user ? (
              <>
                <Link
                  to={user.role === 'admin' ? '/admin' : '/dashboard'}
                  className="btn btn-primary"
                  style={{ padding: '10px 20px', fontSize: '14px' }}
                >
                  {user.role === 'admin' ? '⚡ Admin Panel' : '📊 Dashboard'}
                </Link>
              </>
            ) : (
              <>
                <Link to="/login" className="btn btn-ghost" style={{ padding: '10px 20px', fontSize: '14px' }}>Login</Link>
                <Link to="/pricing" className="btn btn-primary" style={{ padding: '10px 20px', fontSize: '14px' }}>Get Started →</Link>
              </>
            )}
            <button className="hamburger-btn" onClick={() => setMobileOpen(!mobileOpen)}>☰</button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {mobileOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            style={{
              background: 'rgba(10,15,30,0.98)',
              borderTop: '1px solid rgba(255,255,255,0.08)',
              padding: '20px 24px',
              display: 'flex',
              flexDirection: 'column',
              gap: '12px',
            }}
          >
            <Link to="/" onClick={() => setMobileOpen(false)} style={{ padding: '10px', color: 'var(--text-secondary)', fontSize: '15px', fontWeight: 500 }}>Home</Link>
            <Link to="/pricing" onClick={() => setMobileOpen(false)} style={{ padding: '10px', color: 'var(--text-secondary)', fontSize: '15px', fontWeight: 500 }}>Pricing</Link>
            {user ? (
              <>
                <Link to={user.role === 'admin' ? '/admin' : '/dashboard'} onClick={() => setMobileOpen(false)} className="btn btn-primary">Dashboard</Link>
                <button onClick={() => { logout(); setMobileOpen(false); }} className="btn btn-ghost">Logout</button>
              </>
            ) : (
              <>
                <Link to="/login" onClick={() => setMobileOpen(false)} className="btn btn-ghost" style={{ textAlign: 'center' }}>Login</Link>
                <Link to="/pricing" onClick={() => setMobileOpen(false)} className="btn btn-primary" style={{ textAlign: 'center' }}>Get Started</Link>
              </>
            )}
            <Link to="/contact" onClick={() => setMobileOpen(false)} style={{ padding: '10px', color: 'var(--text-secondary)', fontSize: '15px', fontWeight: 500 }}>Contact</Link>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
}
